const productNotFoundInterceptor = require('./productNotFound');

module.exports = {
  productNotFoundInterceptor
}
